module.exports = __webpack_public_path__ + "4ba5f429a15653cf9d8fb4c65aa87c63.svg";